import React, { useState, useEffect, useContext } from 'react';



import { DataContext } from '../../init/getData';
import { PosCartContext } from '../../init/posCartData';

import { Col, Form, Row, DropdownButton, Dropdown, Modal, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, theme, CheckBox } from 'antd';


import Loader from '../../components/loader/loader';

import Category from './items/category';
import Product from './items/product';
import Cart from './items/cart';

import LoadPosJv from './functions/loadPosJv';



function PosForm(props) {

    let { showModal, toggleModal, refFetchData, editedJv, refreshTableFunction, tableNumber, tableMode } = props;

    const { api, userData, settingData, refProductData, devData, selectedCompany, selectedYear, refData, isUsingMainCurrency, currencyData } = useContext(DataContext);
    const { tabData, setJournalVoucher } = useContext(PosCartContext);

    const userRole = userData.role;
    const [loadingCounter, setLoadingCounter] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedTab, setSelectedTab] = useState(0);
    const [selectedPriceType, setSelectedPriceType] = useState('normal');
    const [transactions, setTransactions] = useState(0);

    const controller = new AbortController();

    const createdBy = parseInt(userData.id);
    const companyId = selectedCompany.id;
    const yearId = selectedYear.id;

    const [isPrinting, setIsPrinting] = useState(true);


    const cart = tabData[selectedTab].cart;
    const journalVoucher = tabData[selectedTab].journalVoucher;

    const subTotal = cart?.reduce((e, item) => { return e + parseFloat(item.totalPrice) }, 0);
    const jvCost = cart?.reduce((e, item) => { return e + parseFloat(item.totalCost) }, 0);

    const pointsValue = isUsingMainCurrency ? journalVoucher.pointsValue : journalVoucher.secondaryPointsValue;

    const discountPercentage = journalVoucher.isUsingPoints ? (pointsValue / subTotal) * 100 : (journalVoucher.discountPercentage);
    const totalDiscounts = parseFloat(subTotal * discountPercentage / 100);


    const jvProfit = subTotal - (jvCost + totalDiscounts);

    const totalVatAmount = cart.reduce((sum, item) => { return sum + parseFloat(item.vatAmount * item.netQuantity || 0); }, 0);



    const totalPrice = (subTotal + parseFloat(totalVatAmount)) - totalDiscounts;

    const totalBeforeVat = subTotal - totalDiscounts;
    const selectedCurrency = currencyData?.find(option => option.id === journalVoucher.currencyId);


    const refItems = async () => {
        setIsLoading(true)
        await refFetchData()
        setIsLoading(false)
    }



    useEffect(() => {
        if (journalVoucher.isUsingPoints) {
            let updatedJv = { ...journalVoucher };
            const pointsValue = isUsingMainCurrency ? journalVoucher.pointsValue : journalVoucher.secondaryPointsValue;
            const discountPercentage = (pointsValue / subTotal) * 100;
            updatedJv.discountPercentage = discountPercentage;
            setJournalVoucher(updatedJv, selectedTab)
        }
    }, [cart, journalVoucher.pointsValue, journalVoucher.secondaryPointsValue]);




    return (
        <Modal show={showModal} fullscreen={true}>
            <Modal.Body style={{ backgroundColor: '#f0f2f5', padding: 0 }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: '100vh',
                        overflowY: 'auto',
                        padding: 0,
                        userSelect: 'none',
                    }}
                >
                    {isLoading && <Loader />}

                    {!isLoading && (
                        <>
                            <Category
                                setSelectedCategory={setSelectedCategory}
                                selectedCategory={selectedCategory}
                            />

                            <Product
                                selectedCategory={selectedCategory}
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                refItems={refItems}
                                selectedCurrency={selectedCurrency}
                                journalVoucher={journalVoucher}
                                setSelectedPriceType={setSelectedPriceType}
                                selectedPriceType={selectedPriceType}
                            />

                            <Cart
                                toggleModal={toggleModal}
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                subTotal={subTotal}
                                jvCost={jvCost}
                                jvProfit={jvProfit}
                                totalDiscounts={totalDiscounts}
                                discountPercentage={discountPercentage}
                                totalPrice={totalPrice}
                                totalBeforeVat={totalBeforeVat}
                                totalVatAmount={totalVatAmount}
                                transactions={transactions}
                                journalVoucher={journalVoucher}
                                selectedCurrency={selectedCurrency}
                                editedJv={editedJv}
                                isPrinting={isPrinting}
                                setIsPrinting={setIsPrinting}

                                refreshTableFunction={refreshTableFunction}
                                setSelectedPriceType={setSelectedPriceType}
                                selectedPriceType={selectedPriceType}
                                setTransactions={setTransactions}

                                tableMode={tableMode}
                                tableNumber={tableNumber}
                            />
                        </>
                    )}

                    <LoadPosJv
                        setTransactions={setTransactions}
                        cart={cart}
                        journalVoucher={journalVoucher}
                        selectedCurrency={selectedCurrency}
                        netTotal={totalPrice}
                        totalDiscounts={totalDiscounts}
                        vat={totalVatAmount}
                    />

                </div>
            </Modal.Body>
        </Modal>


    )
}

export default PosForm;
